module.exports = __webpack_public_path__ + "static/media/back-icon.ef4acf08.svg";